var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-f6"},[_c('header',[_c('storeTop')],1),_vm._v(" "),_c('main',{staticClass:"bg-f6",attrs:{"id":"body"}},[_c('router-view')],1),_vm._v(" "),_c('footer',[_c('foot')],1),_vm._v(" "),(_vm.dialogVisible)?_c('loginDialog'):_vm._e(),_vm._v(" "),_c('userProtocolDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }